// modules/land-and-sale/Masterplan.js
import React            from 'react';
import $                from 'jquery';
import PlanButton       from './elements/PlanButton';
import PlanDisplay      from './elements/PlanDisplay';
import SiteDownloadButton    from '../common/SiteDownloadButton';
import PageLoading      from '../PageLoading';
import '../App.css';

import Messenger  from '../common/Messenger';
// import LandSearch from './LandSearch';
let messenger 			= new Messenger();

var sources = require('../config.json');

class Masterplan extends React.Component {
	constructor(props) {
		super(props);

		var d = new Date();
		this.masterplan_url = sources.masterplan + "?ts=" + d.getTime();

		this.state = {
			data: {
			}
		};

		this.receivedMasterplanData = this.receivedMasterplanData.bind(this);
		this.eachElementButton      = this.eachElementButton.bind(this);
		this.planDisplay      		= this.planDisplay.bind(this);
	}

	componentWillMount() {
		window.scrollTo(0, 0);
	}

	componentDidMount() {
		$.ajax({url:this.masterplan_url,dataType:'json'}).done(this.receivedMasterplanData);
	}

	receivedMasterplanData(data, status, xhr) {

		if(typeof data.plan === 'undefined') data.plan = [];
		if(typeof data.elements === 'undefined') data.elements = [];

		let newState = Object.assign(this.state, {
			data: data
		});
		this.setState(newState);
	}

	eachElementButton(element) {
		if (element.length !== 0) {
			let stagetitle = element.name;
			let active = 1;
			if (element.active_lots === 0) {
				stagetitle += "<span>&nbsp;-&nbsp;</span><br/>sold out";
				active = 0;
			} else if (element.active_lots === 1) {
				stagetitle += "<span>&nbsp;-&nbsp;</span><br/>1 lot available";
			} else {
				stagetitle += "<span>&nbsp;-&nbsp;</span><br/>" + element.active_lots + " lots available";
			}
			return (
				<PlanButton
					key={element.id}
					id={element.id}
					messenger={messenger}
					buttonlink={element.link}
					buttonclass={element.class}
					active={active}
					buttonaction="">
					{stagetitle}
				</PlanButton>
			)
		}
	}

	planDisplay(data) {
		if (typeof data.plan.plan_id !== "undefined") {
			return (
				<PlanDisplay key={data.plan.plan_id} messenger={messenger} plan={data.plan} elements={data.elements} plantype="masterplan">Estate Plan</PlanDisplay>
			)
		}
	}

	render() {
		return(
				<div className="app-main">ALL LAND FOR SALE SOLD OUT</div>
		)
		// if (typeof this.state.data.plan !== "undefined") {
		// 	return (
		// 		<div className="App">
		// 			<div className="outer-site-plans">
		// 				<div className="inner-site-plans">
		// 					<h1 className="masterplan-title">Land for sale</h1>
		// 					<div id="MasterplanContainer">
		// 						{this.planDisplay(this.state.data)}
		// 					</div>
		// 					<div id="StageListContainer">
		// 						<a href="#LFSS-Search">
		// 						<div className="LFS-Title">Search All Lots</div>
		// 						</a>
		// 						{this.state.data.elements.map(this.eachElementButton)}
		// 					</div>
		// 					<div className="clear-div"></div>
		// 					<div id="MasterDownloadsContainer">
		// 						<SiteDownloadButton key="1" buttonlink={this.state.data.plan.plan_pdf}>download master plan</SiteDownloadButton>
		// 						<SiteDownloadButton key="2" buttonlink={this.state.data.plan.plan_price_list_pdf}>download price list</SiteDownloadButton>
		// 						<div className="clear-div"></div>
		// 					</div>
		// 				</div>
		// 				<div className="inner-site-downloads">
		// 					<div className="site-downloads-buttons">
		// 						<SiteDownloadButton key="3" buttonlink={this.state.data.plan.local_development_plan}>{'download local<br/>development plan'}</SiteDownloadButton>
		// 						<SiteDownloadButton key="4" buttonlink={this.state.data.plan.design_guidelines}>{'download<br/>design guidelines'}</SiteDownloadButton>
		// 						<SiteDownloadButton key="5" buttonlink={this.state.data.plan.deposited_plan}>{'download<br/>deposited plans'}</SiteDownloadButton>
		// 						<div className="clear-div"></div>
		// 					</div>
		// 				</div>
		// 			</div>
		// 		</div>
		// 	);
		// } else {
		// 	return (
		// 		<PageLoading>Masterplan</PageLoading>
		// 	)
		// }

	}
}

export default Masterplan;



/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/Masterplan.js
 **/